import React from 'react'
import { Button, Tooltip } from "antd";
import { DelvieryIcon } from '../assets/icons/svg_icons'

interface P {
    loading: boolean;
    transparent?: boolean;
    onClick: () => void;
}

export default function PdfExportButton(props: P) {
    return <Tooltip title="Delivery">
        <Button onClick={props.onClick} icon={<DelvieryIcon />} style={{ border: 'none' }} />
    </Tooltip>
}
